import { render, staticRenderFns } from "./editReserveDiningList.vue?vue&type=template&id=009b9a87&scoped=true"
import script from "./editReserveDiningList.vue?vue&type=script&lang=js"
export * from "./editReserveDiningList.vue?vue&type=script&lang=js"
import style0 from "./editReserveDiningList.vue?vue&type=style&index=0&id=009b9a87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009b9a87",
  null
  
)

export default component.exports